<template>
  <div class="dashboard" style="height: 100%; width: 100%; display: flex; flex-direction: column;">
    <loading ref="loadScreen"/>
    <div class="contentDash">
      <div v-for="item in items" v-bind:key="item.id" class="contentCard">
        <div style="display: flex; flex-direction: row;">
          <img v-bind:src="item.thumbnailUrl"/>
          <div style="padding-left: 10px; flex-grow: 1; overflow-x: hidden;">
            <div class="contentTitle">{{item.title}}</div>
            <div v-html="item.description" style="overflow-x: hidden; max-height: 100px; overflow-y: hidden;"/>
          </div>
        </div>
        <router-link :to="{name: 'Ops', params: { id: item.id }}" class="navBtn">Go to item</router-link>
      </div>
    </div>
    <router-link :to="{name: 'Home'}" class="backBtn">Back to GomX</router-link>
    <!-- login menu -->
    <div v-if="needsLogin" class="blockingMenu">
      <div class="card blockingCard" style="display: flex;">
        <div class="cardTitle blockingTitle">Login Required</div>
        <div class="card button green" v-on:click="login">Retry Login</div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '../components/Loading.vue';

import { loadModules } from "esri-loader";

export default {
  name: 'Home',
  components: {
    Loading,
  },
  data: () => ({
    items: []
  }),
  mounted() {
    var globv = this;
    globv.$refs.loadScreen.startLoading()
    globv.login();
  },
  methods: {
    finishLoading: function() {
      var globv = this;
      setTimeout(globv.$refs.loadScreen.finishLoading, 800);
    },
    login: function() {
      var globv = this;
      loadModules(["esri/portal/Portal", "esri/identity/OAuthInfo", "esri/identity/IdentityManager"],{ css: true }).then(async function([Portal, OAuthInfo, esriId]) {
        if (!globv.$store.state.appPortal) {
          var oAuthInfo = new OAuthInfo({
            appId: globv.$store.state.appId,
            portalUrl: globv.$store.state.portalUrl,
            popup: true,
            oAuthPopupConfirmation: false
          });
          esriId.registerOAuthInfos([oAuthInfo]);
          globv.$store.state.appPortal = new Portal({
            url: globv.$store.state.portalUrl
          });
          globv.$store.state.appPortal.authMode = "immediate";
        }

        globv.$store.state.appPortal.load().then(async function(){
          if (globv.$store.state.appPortal.loadError == null) {
            globv.needsLogin = false;
            globv.$refs.loadScreen.finishLoading();
            globv.user = globv.$store.state.appPortal.user.username;
            console.log(globv.$store.state.appPortal.credential.token)


            //validate to server
            // await globv.api
            //   .get("/validateLogin", {
            //     params: {
            //       token: globv.$store.state.appPortal.credential.token
            //     }
            //   })
            //   .catch(function(error) {
            //     globv.setError('Server connection issue', 'ArcGIS Token was unable to be validated, please try again')
            //     console.log(error);
            //   });
            
            //get portal items
            globv.items = (await globv.$store.state.appPortal.queryItems({
              //categories:['Dashboard'],
              query:'accountid:bO0YkhpDndJbAKST AND type:Dashboard'
            })).results

            //https://40geo.maps.arcgis.com/apps/opsdashboard/index.html#/ + id

            console.log(globv.items)
          } else {
            globv.needsLogin = true;
          }
        });
      });
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
.contentDash {
  overflow: scroll;
  margin: auto;
  width: 50%;
}

.contentDash::-webkit-scrollbar {
  display: none;
}

.arcgisItem {
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: center;
    align-self: center;
    width: 100%;
    flex: 1 0 auto;

    > .card {
        max-width: 1140px;
        width: 80%;
    }

    .dashFlexContent {
        width: 80%;

        .chart {
            width: 400px;
        }
    }
}

.contentButton {
  display: flex;
  position: absolute;
  top: 10px;
  right: 10px;

  a {
    padding: 5px 10px;
    display: flex;
    align-items: flex-end;
  }
}

.navBtn {
    align-self: center;
    background-color: #2f55a4;
    position: absolute;
    bottom: 10px;
    right: 10px;
    color: white;
    background-color: var(--primaryColor);
    color: var(--primaryTextColor);
    text-decoration: none;
    padding: 10px 12px;
    border-radius: 5px;
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;

    &:hover, &:focus, &:active {
        transform: scale(1.1);
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.5);
    }
}

.backBtn {
    align-self: center;
    background-color: #2f55a4;
    position: absolute;
    top: 10px;
    right: 10px;
    color: white;
    background-color: var(--primaryColor);
    color: var(--primaryTextColor);
    text-decoration: none;
    padding: 10px 12px;
    border-radius: 5px;
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;

    &:hover, &:focus, &:active {
        transform: scale(1.1);
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.5);
    }
}

.contentCard {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 10px;
    background-color: #fffafa;
    pointer-events: all;
    overflow: hidden;
    margin-top: 10px;
    margin-bottom: 10px;
    position: relative;
}
.contentTitle {
    font-weight: bold;
    font-size: large;
    margin-bottom: 10px;
}
.button {
    text-align: center;
    display: inline-block;
    margin: 0 10px;
    cursor: pointer;
}
.blue {
    background-color: var(--primary);
    color: #fffafa;
}
.grey {
    background-color: grey;
    color: #fffafa;
}
.red {
    background-color: #d62d20;
    color: #fffafa;
}
.green {
    background-color: #0EE831;
    color: #fffafa;
}
.keyInput {
    padding: 8px;
    display: inline-block;
    border: none;
    background-color: #fffafa;
    border: 1px solid #ccc;
    width: 75%;
}
.input {
    display: inline-block;
    border: none;
    background-color: #fffafa;
    border: 1px solid #ccc;
    width: 100%;
}
.blockingMenu {
    position: fixed;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    background-color: rgba(105, 105, 105, 0.6);
}
.blockingCard {
    position: fixed;
    vertical-align: center;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
}
.blockingTitle {
    display: inline-block;
    margin-right: 10px;
}
.rightButtons {
    display: grid;
    justify-content: end;
}
</style>